import * as Sentry from "@sentry/react";
import packageJson from "../../package.json";

/**
 * Initialize Sentry for error tracking.
 * 
 * Configures Sentry with:
 * - DSN for error reporting
 * - Environment detection (development vs production)
 * - Release version from package.json (sent as release, tag, and context)
 * - React integration for error boundaries
 * - Error tracking only (no performance monitoring)
 */
export const initSentry = () => {
  const dsn = "https://9cc01231a4af7429faff836445177018@o4509667237363712.ingest.us.sentry.io/4510409971859456";
  const environment = import.meta.env.MODE === "production" ? "production" : "development";
  const release = `booktimelive@${packageJson.version}`;
  const version = packageJson.version;

  Sentry.init({
    dsn,
    environment,
    release,
    // Error tracking only - no performance monitoring
    tracesSampleRate: 0,
    // Only send errors in production, or if explicitly enabled in dev
    enabled: environment === "production" || import.meta.env.VITE_ENABLE_SENTRY === "true",
  });

  // Set version as a global tag for all events (for filtering in Sentry dashboard)
  Sentry.setTag("version", version);
  Sentry.setTag("app", "booktimelive");
  
  // Set version in context for better visibility
  Sentry.setContext("app", {
    name: "BookTimeLive",
    version: version,
    release: release,
  });
};

